import { createFileRoute } from "@tanstack/react-router";

import { HomePage } from "../../pages/dashboard/home/Home.page";

export const Route = createFileRoute("/_protected/dashboard/")({
  component: HomePage,
});
